import styled from 'styled-components/macro';
import { FormField } from '@redis-ui/components';

export const FormFieldCompose = styled(FormField.Compose)`
  flex: 1;
  &:last-child:not(:only-child) {
    margin-left: 1.8rem;
  }
`;
